<div class="home-container">
    <div class="image">
      <div class="logo">
        <img src="assets/images/home_background.png" alt="Logo" />
      </div>
      <button
        mat-raised-button
        class="enter-button"
        aria-label="enter button"
        (click)="logout()"
      >
        ENTER NOW
      </button>
    </div>
  </div>